import { Modal } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SpreadSheet } from '../SpreadSheet';
import { REVIEW_IMPORT_STEP, UPLOAD_SPREADSHEET_STEP } from '../SpreadSheet/constants';

import * as S from './style';

export function BulkUploadContactModal({ isOpen, onRequestClose }) {
  const { t } = useTranslation();

  const [footerProps, setFooterProps] = useState({});
  const [step, setStep] = useState(UPLOAD_SPREADSHEET_STEP);

  const steps = useMemo(() => {
    return [
      {
        key: UPLOAD_SPREADSHEET_STEP,
        label: t('uploadSpreadsheet'),
        active: step === UPLOAD_SPREADSHEET_STEP,
        completed: step === REVIEW_IMPORT_STEP,
        stepIndex: 1
      },
      {
        key: REVIEW_IMPORT_STEP,
        label: t('reviewConfirm'),
        active: step === REVIEW_IMPORT_STEP,
        completed: step === UPLOAD_SPREADSHEET_STEP,
        stepIndex: 2
      }
    ];
  }, [step]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={t('bulkUploadRecipients')}
      size="xl"
      primaryButtonProps={{
        children: footerProps.rightButtonText,
        onClick: footerProps.rightButtonOnClick,
        disabled: !footerProps.isRightButtonActive,
        endIcon: footerProps.rightButtonEndIcon
      }}
      secondaryButtonProps={{
        onClick: footerProps.leftButtonOnClick,
        children: footerProps.leftButtonText,
        disabled: !footerProps.isLeftButtonActive
      }}
      steps={steps}
      activeStepIndex={footerProps.activeStepIndex}
    >
      <S.Wrapper>
        <SpreadSheet
          setFooterProps={setFooterProps}
          step={step}
          setStep={setStep}
          setActiveScene={onRequestClose}
          onRequestClose={onRequestClose}
        />
      </S.Wrapper>
    </Modal>
  );
}

BulkUploadContactModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onAsyncSubmit: PropTypes.func.isRequired
};
